import { evidenceListOf } from './assessment';

/**
 * The evidence a correction sends for a question (overide.py; the server checks every item in
 * override_evidence.py). Ported from the hl line. The question's whole final list is sent: the saved quotes the
 * reviewer kept, in their order, then the lines they cited. Each item carries only what the server reads — the
 * source, the quote and, for a citation, its time and its line (`seg`) — never a speaker or a name: the server
 * takes the speaker from the verdict or the transcript. Which quotes start kept is evidenceDraft.js's call.
 */

export const MAX_QUOTES = 5;
export const MAX_QUOTE_CHARS = 300;

/** The verdict's saved quotes as the editor lists them: [{quote, speaker, start?, source: 'ai' | 'human'}]. */
export function savedEvidenceOf(parsed) {
  const list = Array.isArray(parsed?.evidenceList) ? parsed.evidenceList : evidenceListOf(parsed);
  return list
    .filter((e) => e && typeof e.quote === 'string' && e.quote.trim())
    .map((e) => ({
      quote: e.quote,
      speaker: e.speaker || '',
      ...(Number.isFinite(e.start) ? { start: e.start } : {}),
      ...(Number.isInteger(e.seg) ? { seg: e.seg } : {}),
      source: e.source === 'human' ? 'human' : 'ai',
    }));
}

export const quoteCount = (keep, cited) => keep.filter(Boolean).length + cited.length;

/** One item as the server reads it. A citation names its line (`seg`), new or saved (the server stores it), and
 * is checked against that line only; one with none has its line found by its time. */
export const wireItem = (row) => {
  if (row.source !== 'human' || !Number.isFinite(row.start)) return { source: 'ai', quote: row.quote };
  return Number.isInteger(row.seg)
    ? { source: 'human', quote: row.quote, start: row.start, seg: row.seg }
    : { source: 'human', quote: row.quote, start: row.start };
};

/** The list to send, or undefined when nothing is kept or cited (the key is then left out). */
export function evidenceToSend(saved, keep, cited) {
  const items = [...saved.filter((_, i) => keep[i]), ...cited].map(wireItem);
  return items.length ? items : undefined;
}
